"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Colors_1 = require("../../../../Colors");
const common_1 = require("../../../../common");
const action_1 = require("../../../menu/action");
const popup_1 = require("../../popup");
const DSSMY001_1 = require("../../../DSS/DSSMY001");
const function_1 = require("../../../menu/function");
const account_1 = require("../../account");
const classes_1 = require("../../classes");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const MobileGNB = react_1.default.memo(({ isWhite, isTeacher, selectedMenu, }) => {
    const { isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [isOpened, setIsOpened] = react_1.default.useState(false);
    const hiddenMenus = (0, react_redux_1.useSelector)((state) => (0, classes_1.getHiddenMenus)(state));
    const sidebarRef = (0, react_1.useRef)(null);
    const updateNewMenu = (depths, menu, id) => {
        dispatch((0, action_1.updateMenu)(depths, menu, id));
    };
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setIsOpened(false);
            }
        };
        if (isOpened) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpened]);
    const renderMenuBar = (0, react_1.useCallback)((depths, list, isParent = false, hasChild = false) => (react_1.default.createElement(common_1.MenuBar, { className: `gnb-menu ${isParent ? 'parent-menu' : ''} ${isParent && !hasChild ? 'no-child' : ''}`, isRow: false, isClickDisabled: false, list: isParent ? [depths] : list, value: selectedMenu, onItemClick: (changeMenu) => {
            const isDepthClick = changeMenu === depths;
            const nextMenu = isDepthClick
                ? (0, function_1.getDefaultMenuByDepth)(depths, isTeacher, hiddenMenus)
                : changeMenu;
            updateNewMenu(depths, {
                menu: nextMenu,
                detail: 'list', // Matches IMenuDetailProps
            } // menu object
            );
            setIsOpened(false);
        } })), [selectedMenu, isTeacher, hiddenMenus]);
    const menuSections = (0, react_1.useMemo)(() => {
        const filteredMenus = (0, function_1.getFilterMenuList)(isTeacher, hiddenMenus);
        return filteredMenus.map(menuKey => ({
            depths: menuKey,
            list: (0, function_1.getVisibleDepthMenus)(menuKey, isTeacher, hiddenMenus),
        }));
    }, [isTeacher, hiddenMenus]);
    return (react_1.default.createElement("div", { className: "mobile-navbar" },
        react_1.default.createElement(common_1.Button, { className: "btn-logo gray", option: {
                buttonBeforeIcon: {
                    show: true,
                    size: 18,
                    color: isWhite ? Colors_1.Colors.white : Colors_1.Colors.black,
                    name: 'menu_open',
                },
            }, onClick: () => setIsOpened(true) }),
        react_1.default.createElement("div", { className: `mobile-gnb ${isOpened ? 'active' : ''}` },
            react_1.default.createElement("div", { className: `mobile-gnb-sidebar ${isTablet && 'tablet-sidebar'}`, ref: sidebarRef },
                react_1.default.createElement("div", { className: "mobile-gnb-header" },
                    react_1.default.createElement(common_1.Button, { className: `btn-logo`, option: {
                            buttonBeforeIcon: {
                                show: true,
                                width: 107,
                                height: 30,
                                name: 'logo',
                            },
                        }, onClick: () => {
                            updateNewMenu('home', { menu: 'home', detail: 'list' });
                            setIsOpened(false);
                        } }),
                    react_1.default.createElement(common_1.Button, { className: `btn-logo gray`, option: {
                            buttonBeforeIcon: {
                                show: true,
                                size: 18,
                                name: 'menu_close',
                            },
                        }, onClick: () => setIsOpened(false) })),
                react_1.default.createElement("div", { className: "mobile-gnb-menu" }, menuSections.map(({ depths, list }) => (react_1.default.createElement("div", { className: "gnb-section", key: depths },
                    renderMenuBar(depths, [], true, list.length > 0),
                    list.length > 0 && renderMenuBar(depths, list))))),
                react_1.default.createElement("div", { className: "mobile-gnb-footer" },
                    false && !isTeacher && (react_1.default.createElement(common_1.Button, { className: "btn-my-academy", text: "menu.myAcademy", onClick: () => {
                            setIsOpened(false);
                            APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                                component: DSSMY001_1.DSSMY001,
                                componentProps: {},
                                title: '소속 학원',
                                width: 560,
                                isFit: true,
                            });
                        } })),
                    react_1.default.createElement(account_1.MyPageDropDown, { isSidebar: true, iconOnly: true }))))));
});
exports.default = MobileGNB;
